(function() {
  function init() {
    var left = document.querySelector('.noxor-pform__left');
    var right = document.querySelector('.noxor-pform__right');
    if (!left) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        setTimeout(function() { left.classList.add('noxor-visible'); }, 0);
        setTimeout(function() { if(right) right.classList.add('noxor-visible'); }, 200);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    observer.observe(left);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
